// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"H5-z","dimensionLabel":"I5-z","styleChooserControlWrapper":"J5-z","styleChooserControl":"K5-z","disabled":"L5-z","giftCard":"M5-z","styleChooserText":"N5-z"};